export enum RingBell {
    doorBell = 'DoorBell',
    swiftlane = 'Swiftlane',
    snapshot = 'Snapshot',
    telephone = 'Telephone',
}
